import AccountSettings from "./AccountSetting";

export const accountsUserRoutes = (data) => [
  {
    path: "/:lang/user/account/account-setting",
    title: "Account Setting",
    layout: data?.user?.role === "organization" ? "user" : "front",
    routeType: ["user", "organization"].includes(data?.user?.role)
      ? data?.user?.role
      : "user",
    component: AccountSettings,
  },
];
